<template>
  <div class="bb-settings-categories-project-total-percent">
    {{item.steps.length}}
    steps
    -
    <span :class="[isError && isErrorTotalPercent && 'bb-settings-categories-project-total-percent_error']">
      {{totalPercent}} %
    </span>
    <div
      v-if="isError"
      class="bb-settings-categories-project-total-percent__info"
    >
      {{errorText}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExpenseCategoriesListOfProjectTotalPercent',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    stepsNoRemove () {
      const { steps = [] } = this.item
      return steps.filter((el) => !el.isRemove)
    },
    isErrorTotalPercent () {
      return this.totalPercent !== 100
    },
    isError () {
      const { isErrorMinStep = false } = this.item
      return this.stepsNoRemove.length && (this.totalPercent !== 100 || isErrorMinStep)
    },
    errorText () {
      const { isErrorMinStep = false } = this.item
      if (this.isErrorTotalPercent) return 'value must be 100%'
      if (isErrorMinStep) return 'Add 1 more step'
    },
    totalPercent () {
      return this.setTotal(this.stepsNoRemove)
    }
  },
  methods: {
    setTotal (steps) {
      const total = steps.reduce((accumulator, item) => {
        const { percent = 0 } = item
        return accumulator + percent
      }, 0)
      this.$set(this.item, 'totalPercent', total)
      return total
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

  .bb-settings-categories-project-total-percent {
    position: relative;
    font-size: 14px;
    line-height: 17px;
    text-align: end;

    &_error {
      color: $color-pomegranate;
    }

    &__info {
      position: absolute;
      right: 0;
      bottom: -17px;
      color: $color-pomegranate;
      white-space: nowrap;
      font-size: 12px;
      line-height: 14px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Settings/ExpenseCategories/ExpenseCategoriesListOfProject/ExpenseCategoriesListOfProjectTotalPercent.vue